import { useFaqWidget } from "../../../providers/context";
import { SpeechButton } from "~/components/Buttons/SpeechButton";

export function FaqSpeechButton() {
	const { textToSpeech } = useFaqWidget();
	return <SpeechButton value={textToSpeech} />;
}